// extracted by mini-css-extract-plugin
export var button = "_9h-4";
export var hasDarkBackground = "_9h-7";
export var hasLightBackground = "_9h-6";
export var iconWrapper = "_9h-0";
export var large = "_9h-2";
export var medium = "_9h-1";
export var small = "_9h-5";
export var xsmall = "_9h-3";